import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetWalletsRequestSchema,
  TGetWalletsResponseSchema,
} from "./getWallets.schema";

export const getWallets = (axios: IAxiosInstance) => {
  return async (params: TGetWalletsRequestSchema) => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetWalletsResponseSchema>
    >(`/api/wallets`, { params });

    return response.data;
  };
};
